import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ActiveLogo from "../img/activelogo.png";
import OvdimBariLogo from "../img/ovdim_bari_logo.png";
import { PoweredBy } from "../shared/PoweredBy";
import { isPartnerClalit, isPartnerOvdimBari, isPartnerNone } from "../store/partnerStore";

const Footer = () => {
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);
  const isNone = useSelector(isPartnerNone);

  const [backUrl, setBackUrl] = useState("https://onelink.to/clalit_active");
  const [text, setText] = useState("");

  useEffect(() => {
    if (isClalit) {
      setBackUrl("https://onelink.to/clalit_active");
      setText(t("BACK_TO_ACTIVE"));
    } else if (isOvdimBari) {
      setBackUrl("https://ovdimbari.onelink.me/l3N5/4ju1o7by");
      setText(t("BACK_TO_OVDIM_BARI"));
    } else {
      setBackUrl("https://meuhedetwow.onelink.me/XrAs?route=/sport");
      setText(t("BACK_TO_WOW"));
    }
  }, [isClalit, isOvdimBari]);

  return (
    <div>
      {!isNone && (
        <footer
          className="main-page-footer"
          style={{ justifyContent: isClalit || isOvdimBari ? "center" : "flex-start" }}
          onClick={() => window.open(backUrl)}
        >
          <p className={isClalit || isOvdimBari ? "main-page-footer-text-active" : "main-page-footer-text-wow"}>{text}</p>
          {isClalit && <img src={ActiveLogo} alt="Active logo" />}
          {isOvdimBari && <img src={OvdimBariLogo} alt="OvdimBari logo" />}
        </footer>
      )}
      {isClalit && <PoweredBy />}
    </div>
  );
};

export default Footer;
